export default Object.freeze({
  moveLeft: -1,
  moveRight: 1,
  moveUp: -1,
  moveDown: 1
});
